<div class="fb-finish-profile-dialog py-4 px-3 md:px-6 flex flex-col justify-center items-center h-full">
	<div (click)="dialogRef.close()"
		 class="absolute top-0 left-0 px-2 pt-2 bg-[#D4A373] rounded z-[2]">
			<span class="material-symbols-outlined cursor-pointer text-white">
				close
			</span>
	</div>
	<div class="fb-scroll-body flex flex-col gap-2">
		<h2 class="font-semibold text-[#3c3c3c] mb-4 text-lg md:text-2xl text-center w-full">{{data.finishProfile.displayName}}</h2>
		<div class="w-full grid grid-cols-2 md:grid-cols-3 gap-1.5 pb-[90px]">
			<div *ngFor="let finish of data.finishProfile.finishProfileItemList"
				 (click)="toggleFinish(finish)"
				 [class.active]="data.selectedFinishes.includes(finish)"
				 class="fb-finish-icon relative rounded-md flex flex-col justify-stretch items-start gap-2 md:gap-4 cursor-pointer">
				<img [src]="finish.image" [alt]="finish.label"
					 class="rounded">
				<div class="flex flex-col gap-2 px-2 pb-2">
					<h3  class="black-text capitalize text-base font-medium">{{finish.label.toLowerCase()}}</h3>
					<div class="text-sm grey-text font-bold">{{selectedCurrency | uppercase}} {{finish.price | currencyConverter | number: '1.0-2'}}</div>
					<p class="text-sm mt-2 grey-text">{{finish.description}}</p>
				</div>
				<svg *ngIf="data.selectedFinishes.includes(finish)"
					 class="absolute -top-2 -left-2"
					 width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
					<g clip-path="url(#clip0_2120_244)">
						<circle cx="10.5001" cy="10.5" r="9.19" fill="white"/>
						<path d="M10.5 1.3125C8.68289 1.3125 6.90658 1.85134 5.3957 2.86087C3.88483 3.87041 2.70724 5.3053 2.01186 6.9841C1.31648 8.66289 1.13454 10.5102 1.48904 12.2924C1.84354 14.0746 2.71857 15.7116 4.00346 16.9965C5.28836 18.2814 6.92541 19.1565 8.70761 19.511C10.4898 19.8655 12.3371 19.6835 14.0159 18.9881C15.6947 18.2928 17.1296 17.1152 18.1391 15.6043C19.1487 14.0934 19.6875 12.3171 19.6875 10.5C19.6875 8.06332 18.7195 5.72645 16.9965 4.00346C15.2736 2.28047 12.9367 1.3125 10.5 1.3125ZM9.1875 14.169L5.90625 10.8877L6.95009 9.84375L9.1875 12.081L14.0503 7.21875L15.0975 8.2595L9.1875 14.169Z" />
					</g>
					<defs>
						<clipPath id="clip0_2120_244">
							<rect width="21" height="21" fill="white"/>
						</clipPath>
					</defs>
				</svg>
			</div>
		</div>
	</div>

	<div class="w-full max-w-[780px] flex flex-col gap-2 justify-end  border-t pt-2">
		<div *ngIf="totalFinishPrice" class="font-medium px-3 mt-3">
			Total: {{selectedCurrency | uppercase}} {{totalFinishPrice | currencyConverter | number: '1.0-2'}}
		</div>
		<div *ngIf="data.selectedFinishes.length > 0" class="fb-selected-finishes px-3">
			<div *ngFor="let finish of data.selectedFinishes"
				 (click)="toggleFinish(finish)"
				 class="fb-finish-chip">
				<span>{{finish.label.toLowerCase()}}</span>
				<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M7.99999 8.00002L4.66666 4.66669M7.99999 8.00002L11.3333 11.3334M7.99999 8.00002L11.3333 4.66669M7.99999 8.00002L4.66666 11.3334" stroke="black" stroke-width="1.3333" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>

			</div>
		</div>
		<div class="flex gap-2 mb-2 mt-0.5">
			<div (click)="onClose(false)"
				 class="w-full rounded-md text-center secondary-button py-3 mx-1  font-medium cursor-pointer">
				Cancel
			</div>
			<div (click)="onClose(true)"
				 class="w-full rounded-md text-center primary-button py-3 mx-1 font-medium cursor-pointer">
				Continue
			</div>
		</div>

	</div>
</div>
